import React from "react";
import { useTranslation } from "react-i18next";
import { Stepper } from "../../../../common/components";
import { useSetUpSpacesStore } from "../../store";
import { STEPPER_STEPS_FLOW } from "../../constants";

interface DialogStepperProps {
    activeStep: string;
} 

export const DialogStepper = (props: DialogStepperProps) => {
    const {
        activeStep,
    } = props;

    const { t } = useTranslation(["setUpSpaces"]);

    const { flowType } = useSetUpSpacesStore();

    const stepperSteps = STEPPER_STEPS_FLOW[flowType].map((STEP) => ({
        label: t(`setUpSpaces:stepperSteps.${STEP}`),
        isCurrent: STEP === activeStep,
    }));

    return (
        <p>
            <Stepper
                steps={stepperSteps}
                />
        </p>
    )
};